/**
 * Search query helpers.
 *
 * Field-scoped queries (title:… OR variants.sku:…) used to force keyword
 * matching and avoid Shopify semantic search. Storefront search now returns
 * 0 results for those field queries, which broke SKU/code lookup (CCA, etc).
 * New searches are left unscoped; old scoped URLs are unwrapped once.
 */
if (!window.theme) window.theme = {};

theme.buildKeywordScopedQuery = function buildKeywordScopedQuery(raw) {
  return (raw || '').trim();
};

theme.getOriginalSearchTerms = function getOriginalSearchTerms(params = new URLSearchParams(window.location.search)) {
  const oq = params.get('oq');
  if (oq) return oq.trim();

  const q = (params.get('q') || '').trim();
  if (!q) return '';
  if (!/\b(title|product_type|vendor|tag|sku|variants\.sku):/i.test(q)) return q;

  const matches = [...q.matchAll(/(?:title|product_type|vendor|tag|sku|variants\.sku):([^\s()]+)/gi)];
  const words = [];
  matches.forEach((match) => {
    const word = (match[1] || '').replace(/\*+$/, '');
    if (word && !words.includes(word)) words.push(word);
  });
  return words.join(' ') || q;
};

theme.shouldScopeSearchQuery = function shouldScopeSearchQuery() {
  return false;
};

theme.isScopedSearchQuery = function isScopedSearchQuery(raw) {
  return /\b(title|product_type|vendor|tag|sku|variants\.sku):/i.test((raw || '').trim());
};

(function unwrapScopedSearchQueries() {
  if (!/\/search\/?$/.test(window.location.pathname)) return;

  const params = new URLSearchParams(window.location.search);
  const q = (params.get('q') || '').trim();
  if (!q || !theme.isScopedSearchQuery(q)) return;

  const original = theme.getOriginalSearchTerms(params);
  if (!original || original === q) return;

  params.set('q', original);
  params.delete('oq');
  window.location.replace(`${window.location.pathname}?${params.toString()}`);
}());
